import React from "react";
import { Footer, Navbar } from "../components";
import { useSelector } from "react-redux";
import { Link,useLocation  } from "react-router-dom";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME,Image_Base_Url,ACCESS_Role_ID,ACCESS_Log_In_User_Id } from '../constants/apiConstants';

import "../assets/stylesheet/bootstrap.min.css";
import "../assets/stylesheet/all-fontawesome.min.css";
import "../assets/stylesheet/animate.min.css";
import "../assets/stylesheet/magnific-popup.min.css";
import "../assets/stylesheet/owl.carousel.min.css";
import "../assets/stylesheet/style.css";
const CourseCheckout = () => {
  const location = useLocation();
    const amount = location.state?.amount; // Retrieve the amount from state

  const EmptyCart = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">No item in Cart</h4>
            <Link to="/" className="btn btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const ShowCheckout = () => {
    let subtotal = 0;
    let shipping = 30.0;
    let totalItems = 0;
    state.map((item) => {
      return (subtotal += item.price * item.qty);
    });

    state.map((item) => {
      return (totalItems += item.qty);
    });
    return (
      <>
        <div className="container py-5">
          <div className="row my-4">
            <div className="col-md-5 col-lg-4 order-md-last">
              <div className="card mb-4">
                <div className="card-header py-3 bg-light">
                  <h5 className="mb-0">Order Summary</h5>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                      Products ({totalItems})<span>${Math.round(subtotal)}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                      Shipping
                      <span>${shipping}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                      <div>
                        <strong>Total amount</strong>
                      </div>
                      <span>
                        <strong>${Math.round(subtotal + shipping)}</strong>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="card mb-4">
                <div className="card-header py-3">
                  <h4 className="mb-0">Billing address</h4>
                </div>
                <div className="card-body">
                  <form className="needs-validation" novalidate>
                    <div className="row g-3">
                      <div className="col-sm-6 my-1">
                        <label htmlFor="firstName" className="form-label">
                          First name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="firstName"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Valid first name is required.
                        </div>
                      </div>

                      <div className="col-sm-6 my-1">
                        <label htmlFor="lastName" className="form-label">
                          Last name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="lastName"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Valid last name is required.
                        </div>
                      </div>

                      <div className="col-12 my-1">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="you@example.com"
                          required
                        />
                        <div className="invalid-feedback">
                          Please enter a valid email address for shipping
                          updates.
                        </div>
                      </div>

                      <div className="col-12 my-1">
                        <label htmlFor="address" className="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          placeholder="1234 Main St"
                          required
                        />
                        <div className="invalid-feedback">
                          Please enter your shipping address.
                        </div>
                      </div>

                      <div className="col-12">
                        <label htmlFor="address2" className="form-label">
                          Address 2{" "}
                          <span className="text-muted">(Optional)</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address2"
                          placeholder="Apartment or suite"
                        />
                      </div>

                      <div className="col-md-5 my-1">
                        <label htmlFor="country" className="form-label">
                          Country
                        </label>
                        <br />
                        <select className="form-select" id="country" required>
                          <option value="">Choose...</option>
                          <option>India</option>
                        </select>
                        <div className="invalid-feedback">
                          Please select a valid country.
                        </div>
                      </div>

                      <div className="col-md-4 my-1">
                        <label htmlFor="state" className="form-label">
                          State
                        </label>
                        <br />
                        <select className="form-select" id="state" required>
                          <option value="">Choose...</option>
                          <option>Punjab</option>
                        </select>
                        <div className="invalid-feedback">
                          Please provide a valid state.
                        </div>
                      </div>

                      <div className="col-md-3 my-1">
                        <label htmlFor="zip" className="form-label">
                          Zip
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="zip"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Zip code required.
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    <h4 className="mb-3">Payment</h4>

                    <div className="row gy-3">
                      <div className="col-md-6">
                        <label htmlFor="cc-name" className="form-label">
                          Name on card
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-name"
                          placeholder=""
                          required
                        />
                        <small className="text-muted">
                          Full name as displayed on card
                        </small>
                        <div className="invalid-feedback">
                          Name on card is required
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="cc-number" className="form-label">
                          Credit card number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-number"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Credit card number is required
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="cc-expiration" className="form-label">
                          Expiration
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-expiration"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Expiration date required
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="cc-cvv" className="form-label">
                          CVV
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-cvv"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Security code required
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    <button
                      className="w-100 btn btn-primary "
                      type="submit" disabled
                    >
                      Continue to checkout
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        {/* <h1 className="text-center">Checkout</h1> */}
        <div class="search-popup">
        <button class="close-search"><span class="far fa-times"></span></button>
        <form action="#">
            <div class="form-group">
                <input type="search" name="search-field" placeholder="Search Here..." required/>
                <button type="submit"><i class="far fa-search"></i></button>
            </div>
        </form>
    </div>
        <hr />
        {/* {state.length ? <ShowCheckout /> : <EmptyCart />} */}
        <main class="main bg_all">
       
        <div class="course-single-area py-5">
            <div class="container">
                <div class="course-single-wrapper">
                    <div class="row">
                        <div class="col-xl-8 col-lg-8">
                            {/* <div class="course-details course_wraper">

                                <div class="course-details">
                                    <div class="tp-cart-list mb-25 mr-30">
                                        <h2 class="pb-2">Billing details</h2>

                                        <form action="#">
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>First Name</label>
                                                        <input type="text" class="form-control" name="firstname" placeholder="Your First Name"/>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>Last Name</label>
                                                        <input type="text" class="form-control" name="lastname" placeholder="Your Last Name"/>
                                                    </div>
                                                </div>


                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>Country / Region *</label>
                                                        <select class="form-select" name="program">
                                                            <option value="">India</option>
                                                            <option value="1">Jordan</option>
                                                            <option value="2">Kenya</option>
                                                            <option value="3">Kuwait</option>
                                                            <option value="4">Kyrgyzstan</option>

                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>Postcode / ZIP</label>
                                                        <input type="text" class="form-control" name="billing_postcode" placeholder="Your Email Address"/>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>Town / City *</label>
                                                        <input type="text" class="form-control" name="billing_city" placeholder="Town / City"/>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>Street address *</label>
                                                        <input type="text" class="form-control" name="billing_address" placeholder="House number and street name"/>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>Email Address</label>
                                                        <input type="email" class="form-control" name="email" placeholder="Your Email Address"/>
                                                    </div>
                                                </div>


                                                <div class="col-lg-6">
                                                    <div class="form-group">
                                                        <label>Contact Number</label>
                                                        <input type="text" class="form-control" name="number" placeholder="Your Contact Number"/>
                                                    </div>
                                                </div>

                                                <h4 class="pt-3">Additional information</h4>

                                                <div class="col-lg-12 pt-2">
                                                    <div class="form-group">
                                                        <label>Order notes </label>
                                                        <textarea name="order_comments" class="form-control " id="order_comments" placeholder="Notes about your order, e.g. special notes for delivery." rows="2" cols="5"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                    </div>

                                </div>


                            </div> */}
                        </div>
                        <div class="col-xl-4 col-lg-4">
                            <div class="course-single-sidebar course_wraper-right">

                                <div class="widget">

                                    <div class="course-feature-list">

                                        <h3>Your order</h3>

                                        <div>
                                            <a href="#" class="pd-cart-checkout-top">Product <span>{amount}</span></a>

                                        </div>


                                        <div>
                                            <a href="#" class="pd-cart-checkout-top">Subtotal <span>{amount}</span></a>

                                        </div>

                                        <div> <a href="#" class="pd-cart-checkout-top">Total <span>{amount}</span></a>

                                        </div>


                                        <div class="form-check">

                                            <label class="form-check-label" for="radio1">Direct Bank Transfer</label><input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" checked/>


                                            <div class="payment-box">
                                                <p>Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order won’t be shipped until the funds have cleared in our account.</p>
                                            </div>

                                        </div>

                                        <div class="form-check">
                                            <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" checked/>
                                            <label class="form-check-label" for="radio1">Cheque Payment </label>

                                        </div>

                                        <div class="form-check">
                                            <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" checked/>
                                            <label class="form-check-label" for="radio1">Cash on Delivery</label>

                                        </div>


                                        <div class="form-check">
                                            <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" checked/>
                                            <label class="form-check-label" for="radio1">PayPal <img src="assets/img/paypal.png" alt="PayPal acceptance mark" style={{width:'20%',paddingLeft:"30px"}}/></label>

                                        </div>

                                    </div>
                                </div>
                                <a href="#" class="theme-btn mt-0"> Place Order <i class="fas fa-arrow-right-long"></i></a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   
    </main>

        <button class="btn btn-primary enquire_now" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Enquire Now</button>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header">
        <h4 id="offcanvasRightLabel">Enquire <span class="orange">Now</span></h4>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <div class="row contact-form py-0">
            <div class="col-md-12">
                <div class="form-group">
                    <input type="text" class="form-control" name="name" placeholder="Your Name" required=""/>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <input type="email" class="form-control" name="email" placeholder="Your Email" required=""/>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <input type="phone" class="form-control" name="phone" placeholder="Your Contact Number" required=""/>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <select class="form-select form-control" aria-label="city">
                            <option selected>City</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <select class="form-select form-control" aria-label="courses">
                            <option selected>Courses</option>
                            <option value="1">MBA</option>
                            <option value="2">BBA</option>
                            <option value="3">Btech</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <select class="form-select form-control" aria-label="courses">
                            <option selected>College for Admission</option>
                            <option value="1">MBA</option>
                            <option value="2">BBA</option>
                            <option value="3">Btech</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Write Your Message"></textarea>
                    </div>
                </div>
                <button type="submit" class="theme-btn">Submit
                    <i class="far fa-paper-plane"></i></button>
            </div>
        </div>
    </div>
</div>
      </div>
      <Footer />
    </>
  );
};

export default CourseCheckout;
